import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";
import AddSnippetForm from "../forms/AddSnippetForm";
import { KnowledgeItem } from "@/services/fileService";

interface SnippetCreationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (item?: KnowledgeItem) => void;
  agentId?: string | null;
}

const SnippetCreationModal = ({
  open,
  onOpenChange,
  onSuccess,
  agentId,
}: SnippetCreationModalProps) => {
  const handleSuccess = (item?: KnowledgeItem) => {
    if (onSuccess) {
      onSuccess(item);
    } else {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] my-8 max-h-[calc(100vh-4rem)] flex flex-col p-0">
        <div className="flex-shrink-0 p-6 pb-4">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-purple-600" />
              Create Text Snippet
            </DialogTitle>
            <DialogDescription>
              Create a text snippet from your own knowledge or notes to make it
              searchable by{" "}
              {agentId ? "your agent" : "agents in your organization"}
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="flex-1 overflow-y-auto px-6 pb-4">
          <AddSnippetForm
            onSuccess={handleSuccess}
            agentId={agentId}
            renderButton={({
              isLoading,
              isAgentSpecific,
              selectedAgentId,
              getSelectedAgentName,
              isAiProcessing,
            }) => (
              <div className="sticky bottom-0 bg-background pt-4 mt-6 border-t">
                <div className="flex justify-end">
                  <Button
                    type="submit"
                    disabled={
                      isLoading || (isAgentSpecific && !selectedAgentId)
                    }
                  >
                    {isLoading ? (
                      <>
                        <span className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-current border-t-transparent" />
                        {isAiProcessing ? "Processing..." : "Creating..."}
                      </>
                    ) : (
                      <>
                        Create Snippet{" "}
                        {isAgentSpecific && selectedAgentId
                          ? `for ${getSelectedAgentName()}`
                          : "for Organization"}
                      </>
                    )}
                  </Button>
                </div>
              </div>
            )}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SnippetCreationModal;
